<template>
  <div class="space-between-y">
    <el-dialog title="需求详情" :visible.sync="detail.dialog" width="800px">
      <div class="space-between-y">
        <demand-detail @examined="handleExamined" :id="detail.demand.id" v-if="detail.dialog"></demand-detail>

        <div class="footer-btns">
          <template v-if="detail.demand?.examine === 'PENDING'">
            <el-button @click="examine('REJECTED')">审核驳回</el-button>
            <el-dropdown>
              <el-button type="primary">
                审核通过<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="examine('APPROVED',true)">审核通过直接发布</el-dropdown-item>
                <el-dropdown-item @click.native="examine('APPROVED',false)">仅审核通过</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <template v-else>
            <el-button @click="examine('PENDING')">撤销审核</el-button>
            <el-button v-if="!detail?.onSale" plain type="primary" @click="toPublish(true)">发布</el-button>
            <el-button v-else plain type="danger" @click="toPublish(false)">下架</el-button>
          </template>
        </div>
      </div>

    </el-dialog>

    <div class="both-sides">
      <div class="space-between-x container-left">
        <input-item label="按关键字搜索">
          <el-input clearable v-model="filter.keyword" placeholder="请输入关键字"></el-input>
        </input-item>
        <input-item label="审核状态">
          <el-select @change="getData" clearable v-model="filter.status" placeholder="请选择审核状态">
            <el-option v-for="item in option.examine" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </input-item>
        <input-item>
          <el-button type="primary" @click="getData()">搜索</el-button>
        </input-item>

      </div>

    </div>

    <el-table :data="list" border stripe>
      <el-table-column prop="id" label="id" width="50"></el-table-column>
      <el-table-column prop="parentNickname" label="提交人" width="120">
        <template slot-scope="scope">
          <div class="user">
            <cloud-img :url="scope.row.avatar" :border-radius="5" :img-height="25" :img-width="25"></cloud-img>
            <line-overflow :content="scope.row.parentNickname"></line-overflow>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="需求标题">
        <template slot-scope="scope">
          <line-overflow :content="scope.row.name"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="需求描述">
        <template slot-scope="scope">
          <line-overflow :content="scope.row.desc"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="examine" label="审核状态" width="90">
        <template slot-scope="scope">
          <span class="examine-status" v-if="scope.row.examine === 'PENDING'" style="color: #409EFF">待审核</span>
          <span class="examine-status" v-else-if="scope.row.examine === 'APPROVED'"
                style="color: #67C23A">审核通过</span>
          <span class="examine-status" v-else-if="scope.row.examine === 'REJECTED'"
                style="color: #F56C6C">审核失败</span>
        </template>
      </el-table-column>
      <el-table-column prop="onSale" label="是否发布" width="80">
        <template slot-scope="scope">
          {{ scope.row.onSale ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.price !== null">
            {{ scope.row.price }} 元
          </div>
          <div v-else class="info-text">面谈</div>

        </template>
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleShow(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getData()"></pagination>

  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";
import Pagination from "@/components/base/layout/Pagination.vue";
import TeacherDetail from "@/components/miu/TeacherDetail.vue";
import MiuDesc from "@/components/MiuDesc.vue";
import {miuDemand} from "@/api/miu/miuDemand";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import DemandDetail from "@/components/miu/DemandDetail.vue";

export default {
  name: 'MiuDomand',
  components: {
    DemandDetail,
    CloudImg,
    MiuDesc,
    TeacherDetail,
    Pagination,
    LineOverflow,
    InputItem
  },

  data() {
    return {
      list: [],

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      option: {
        tag: [],
        examine: [
          {
            label: '全部',
            value: null
          },
          {
            label: '待审核',
            value: "PENDING"
          },
          {
            label: '审核通过',
            value: "APPROVED"
          },
          {
            label: '审核失败',
            value: "REJECTED"
          },
        ],
      },

      filter: {
        keyword: "",
        status: null,
        tagIds: [],
      },

      detail: {
        dialog: false,
        demand: null,
      },
    }
  },

  created() {
    this.getData();
  },

  methods: {
    toPublish(publish) {
      let str = publish ? '发布' : '下架';

      this.$confirm("确定" + str + "吗？").then(() => {
        miuDemand.publish(this.detail.demand.id, publish).then(res => {
          this.$message.success(str + "成功");
          this.$emit("examined");
        })
      })
    },

    examine(code, publish) {
      // 审批通过
      if (code === 'APPROVED') {
        this.$confirm("确定通过审核吗？").then(() => {
          miuDemand.examine(this.detail.demand.id, 'APPROVED').then(res => {
            this.$message.success("审核成功");

            if (publish) {
              miuDemand.publish(this.detail.demand.id, publish).then(() => {
                this.$message.success("发布成功");
              })
            }

            this.detail.dialog = false;
            this.getData();
          })
        })
      }
      // 审批驳回
      else if (code === 'REJECTED') {
        this.$prompt("请输入驳回理由", "驳回理由", {}).then(({value}) => {
          miuDemand.examine(this.detail.demand.id, 'REJECTED', value).then(() => {
            this.$message.success("审核成功");
            this.detail.dialog = false;
            this.getData();
          })
        })
      }

      // 撤销审核
      else if (code === 'PENDING') {
        this.$confirm("确定撤销审核吗？该记录将还原到未审核状态！").then(() => {
          miuDemand.examine(this.detail.demand.id, 'PENDING', null).then(() => {
            this.$message.success("审核成功");
            this.detail.dialog = false;
            this.getData();
          })
        })
      }
    },

    handleExamined() {
      this.detail.dialog = false;
      this.detail.service = null;
      this.getData();
    },

    handleShow(item) {
      this.detail.demand = item;
      this.detail.dialog = true;
    },

    getData() {
      miuDemand.list(this.page.size, this.page.current, this.filter.status, this.filter.keyword).then(res => {
        let page = res.data;
        this.page.total = page.total;
        this.list = page.list;
      })
    },
  }

};
</script>

<style scoped>
.user {
  display: flex;
  align-items: center;
}

.footer-btns {
  display: flex;
  justify-items: center;
  gap: 12px;
  justify-content: center;
}
</style>
